import React from "react";
import Marquee from "react-fast-marquee";
import styled from "styled-components";
import tw from "twin.macro";

const BackgroundContainer = styled.div`
  ${tw`w-full`}
  background-color: #fafafa;
  padding: 0; /* Optional padding for spacing */
  margin-bottom: 30px; /* Optional margin for spacing */
  margin-top: -20px;
`;

const LogoContainer = styled.div`
  ${tw`flex items-center justify-center p-4 mx-4`}
  width: 250px;
  img {
    max-width: 100%;
    max-height: 100%;
  }
`;

const partnerLogos = [
  require("../../images/GroupCompany/glam.png"),
  require("../../images/GroupCompany/kes.png"),
  require("../../images/GroupCompany/ncc.png"),
  require("../../images/GroupCompany/unics.png"),
  require("../../images/GroupCompany/glam.png"),
  require("../../images/GroupCompany/kes.png"),
  require("../../images/GroupCompany/ncc.png"),
  require("../../images/GroupCompany/unics.png"),
];

export default () => {
  return (
    <BackgroundContainer>
      <Marquee gradientColor="#fafafa" gradient={true} speed={50}>
        {partnerLogos.map((logo, index) => (
          <LogoContainer key={index}>
            <img src={logo} alt={`Partner Logo ${index + 1}`} />
          </LogoContainer>
        ))}
      </Marquee>
    </BackgroundContainer>
  );
};
